import { useState, useCallback, useMemo } from 'react';
import { subYears } from 'date-fns';
import { localStorageGetItem, localStorageSetItem } from '../components/storage/localStorageManager';
import { MarketPlaceCandidateFormData } from '../types/candidate';
import { sessionStorageGetItem, sessionStorageSetItem } from '../components/storage/sessionStorageManager';

export const useCandidateForm = () => {
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const [combinedLengthError, setCombinedLengthError] = useState('');
    const [userPhoneCodeError, setUserPhoneCodeError] = useState('');

    const [isStateValueAvailable, setIsStateValueAvailable] = useState(true);
    const [isCityValueAvailable, setIsCityValueAvailable] = useState(true);
    const [stateDisabled, setStateDisabled] = useState(true);
    const [cityDisabled, setCityDisabled] = useState(true);
    const [iso2CountryString, setIso2CountryString] = useState('');
    const [iso2StateString, setIso2StateString] = useState('');

    const handleDateChange = useCallback((date: Date) => {
        setSelectedDate(date);
        // sessionStorageSetItem('selectedDate', date.toISOString(), true);
    }, []);

    const getCombinedNameError = useCallback((values: MarketPlaceCandidateFormData) => {
        const combinedLength =
            (values.FirstName || '').length + (values.MiddleName || '').length + (values.LastName || '').length;

        if (combinedLength > 100) {
            setCombinedLengthError('Candidate name cannot exceed 100 characters.');
        } else {
            setCombinedLengthError('');
        }
    }, []);

    const dateConstraints = useMemo(
        () => ({
            minDate: subYears(new Date(), 65),
            maxDate: subYears(new Date(), 18),
        }),
        []
    );

    const storedDate = useMemo(() => {
        const storedDateStr = sessionStorageGetItem('selectedDate', true);
        return storedDateStr ? new Date(storedDateStr) : null;
    }, []);

    return {
        selectedDate,
        combinedLengthError,
        userPhoneCodeError,
        setUserPhoneCodeError,
        handleDateChange,
        getCombinedNameError,
        dateConstraints,
        storedDate,
        dropdownState: {
            isStateValueAvailable,
            isCityValueAvailable,
            stateDisabled,
            cityDisabled,
            iso2CountryString,
            iso2StateString,
            setIsStateValueAvailable,
            setIsCityValueAvailable,
            setStateDisabled,
            setCityDisabled,
            setIso2CountryString,
            setIso2StateString,
        },
    };
};
